import React from 'react'

import Select from 'Components/Select'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} style={{ padding: '5px 0' }}
                                          title={props.title}
                                          buttons={(props.comboMultipleOption(props.options)).length > 0 && !props.disabled &&
                                          <button type="button" onClick={props.onClickAddComboMultiBool}
                                                  className="text-success ei-commun_ajouter"
                                                  style={{ display: 'inline-block', marginLeft: 5 }}/>}>

  {
    (props.data !== undefined ? props.data : []).map((data, index) => (

      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
            alignItems={'center'}>
        <Grid item style={{ margin: 0, padding: 0 }}>
          <button type="button" onClick={() => props.onClickBoolComboMultiBool(index)}
                  disabled={props.disabled || false}
                  className={'ei-commun_pouce ei-' + (data.valeur_bool === true || data.valeur_bool === 1 || parseInt(data.valeur_bool) === 1 ? 'up primaryColor' : 'down secondaryColor')}/>
        </Grid>
        <Grid item xs style={{ margin: 0, padding: 0 }}>
          <Select style={props.style} options={props.comboMultipleOption(props.options, data.id)}
                  disabled={props.disabled || false}
                  name={index}
                  onChange={props.onChangeComboMultiBool}
                  value={data.id}/>
        </Grid>
        {!props.disabled && <Grid item style={{ margin: 0, padding: 0 }}>
          <button type="button" onClick={() => props.onClickRemoveComboMultiBool(index)}
                  className="text-danger ei-commun_enlever"
                  disabled={props.disabled || false}/>
        </Grid>}

      </Grid>
    ))
  }
</Title>)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboMultiBool.js